import type { ConditionItem } from '-/Base/ConditionBox'
export enum DATA_INDEX {
  FILE_NAME = 'fileName',
  FILE_SHOW_NAME = 'fileShowName',
  FILE_SHOW_TIME = 'fileShowTime',
  FILE_CODE_NUMBER = 'fileCodeNumber',
  FILE_SIZE = 'fileSize',
  ID = 'id'
}
export const CONDITION_CONFIG: ConditionItem[] = [
  {
    title: '文件名称',
    dataIndex: DATA_INDEX.FILE_SHOW_NAME,
    atom: 'like'
  },
  {
    title: '文件展示名',
    dataIndex: DATA_INDEX.FILE_SHOW_NAME,
    atom: 'like'
  },
  {
    title: '文件编号',
    dataIndex: DATA_INDEX.FILE_CODE_NUMBER,
    atom: 'like'
  },
  {
    title: '文件时间',
    dataIndex: DATA_INDEX.FILE_SHOW_TIME,
    atom: 'between',
    type: 'dateTimeRangePicker'
  }
]
